import { Location } from "gen/company/models_pb"
import { UUID as PBUUID } from "gen/proto/uuid/models_pb"
import { UUID } from "shared-ts/classes/uuid"
import { QueryParams, WebUrl } from "shared-web/lib/webUrl"

import { encodeQueryParam } from "hooks/filters/useWebFilter"

export function billPayments(location?: Pick<Location, "id" | "name">): WebUrl {
  const pathname = `/pos/receivables/paid`

  if (!location) {
    return { pathname }
  }

  const query: QueryParams = {
    locations: encodeQueryParam(
      {
        key: UUID.idString(location.id),
        value: location.name,
      },
      true
    ),
  }

  return { pathname, query }
}

export function billRefunds(location?: Pick<Location, "id" | "name">): WebUrl {
  const pathname = `/pos/receivables/refunded`

  if (!location) {
    return { pathname }
  }

  const query: QueryParams = {
    locations: encodeQueryParam(
      {
        key: UUID.idString(location.id),
        value: location.name,
      },
      true
    ),
  }

  return { pathname, query }
}

export function bill(id?: PBUUID, isRefund?: boolean): WebUrl {
  const pathname = `/pos/receivables/${UUID.idString(id)}`
  const status = isRefund ? "refunded" : "paid"

  return {
    pathname,
    query: { status },
  }
}

export function newBill(): WebUrl {
  return {
    pathname: "/pos/receivables/payment",
  }
}
